import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/app/store'

type dialogApplySliceState = {
  formOpen: boolean
  formComfirm: boolean
  formFinish: boolean
}

const initialState: dialogApplySliceState = {
  formOpen: true,
  formComfirm: true,
  formFinish: true,
}

const dialogApplySliceReducer = createSlice({
  name: 'dialogApplySlice',
  initialState: initialState,
  reducers: {
    dialogApplyState(state, action) {
      state.formOpen = action.payload
    },
    dialogApplyComfirmState(state, action) {
      state.formComfirm = action.payload
    },
    dialogApplyFinishState(state, action) {
      state.formFinish = action.payload
    },
  },
})

export const {
  dialogApplyState,
  dialogApplyComfirmState,
  dialogApplyFinishState,
} = dialogApplySliceReducer.actions

export const selectApply = (state: RootState) => state.dialogApplyState.formOpen
export const selectApplyComfirm = (state: RootState) =>
  state.dialogApplyComfirmState.formOpen
export const selectApplyFinish = (state: RootState) =>
  state.dialogApplyFinishState.formOpen

export default dialogApplySliceReducer.reducer
